import { red } from '@mui/material/colors';
import theme from '../../../conf/theme';

export const RequestFormCss = () => {
  const formCss = {
    redText: {
      color: red[500],
    },
    hintText: {
      fontSize: theme.typography.pxToRem(10),
    },
  };
  return formCss;
};
